import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tooltip, InputNumber, TimePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate, maskHora } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import TipoAtividadeFrame from './TipoAtividadeFrame';
import MotivoVisitaFrame from './MotivoVisitaFrame';
import { getUsuario, getTemPermissao } from "../utils/LoginManager";

const formatHora = 'HH:mm';
const { Item: ItemForm } = Form;


export default class AtividadeForm extends Component {
  state = {
    registro: {
      ativ_idf: 0,
      ativ_atividade: { key: '1' },
      ativ_data_ativ: moment().format('DD/MM/YYYY'),
      ativ_hora_ini: '00:00',
      ativ_hora_fim: '00:00',
      ativ_data_checkin: '',
      ativ_data_checkout: '',
      ativ_local_checkin: '',
      ativ_local_checkout: '',
      ativ_obs: '',

      ativv_motivo_visita: { key: '3' },
      ativv_idf_venda: 0,
      ativv_cliente: { key: '0' },
      ativv_nome_cliente: '',
      ativv_venda: 0,
      ativr_relatorio: '',

      ativa_km_ini: 0,
      ativa_km_fim: 0,
      ativa_km_rodado: 0,
      ativa_km: 0,
      ativa_qtde_comb: 0,

    },

    editando: false,
    visualizando: false,
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado,
        ativv_cliente: this.props.registroSelecionado.ativv_cliente,
        ativ_usuario: this.props.registroSelecionado.ativ_usuario,
        editando: false,
      }, () => {
        this.mostraCliente();
      });

      if (this.props.registroSelecionado.ativ_idf) {
        this.setState({
          editando: true,
        });
      }
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }

  mostraCliente = () => {
    this.setState({
      registro: {
        ...this.state.registro,
        ativv_cliente: this.state.registro.ativv_cliente,
      },
    });
  }

  onOK = () => {
    if ((!this.state.registro.ativ_data_ativ) || (!moment(this.state.registro.ativ_data_ativ, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }
    if ((!this.state.registro.ativ_usuario) || (this.state.registro.ativ_usuario.key === '0') || (this.state.registro.ativ_usuario.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Usuário', });
      return;
    }

    const registro = {
      ativ_idf: this.state.registro.ativ_idf,
      ativ_usuario: this.state.registro.ativ_usuario.key,
      ativ_atividade: parseInt(this.state.registro.ativ_atividade.key),
      ativ_data_ativ: moment(this.state.registro.ativ_data_ativ, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      ativ_hora_ini: this.state.registro.ativ_hora_ini,
      ativ_hora_fim: this.state.registro.ativ_hora_fim,
      ativ_obs: this.state.registro.ativ_obs,
      ativ_data_checkin: this.state.registro.ativ_data_checkin,
      ativ_local_checkin: this.state.registro.ativ_local_checkin,
      ativ_data_checkout: this.state.registro.ativ_data_checkout,
      ativ_local_checkout: this.state.registro.ativ_local_checkout,

      ativv_motivo_visita: this.state.registro.ativv_motivo_visita.key ? parseInt(this.state.registro.ativv_motivo_visita.key) : 0,
      ativv_venda: this.state.registro.ativv_venda ? 1 : 0,
      ativv_idf_venda: this.state.registro.ativv_idf_venda ? this.state.registro.ativv_idf_venda : 0,

      ativv_cliente: this.state.registro.ativv_cliente && this.state.registro.ativv_cliente.key ? this.state.registro.ativv_cliente.key : 0,

      ativv_nome_cliente: ((!this.state.registro.ativv_cliente) || (this.state.registro.ativv_cliente.key === '0') || (this.state.registro.ativv_cliente.key === '')) ? this.state.registro.ativv_nome_cliente : '',

      ativr_relatorio: this.state.registro.ativr_relatorio,

      ativa_km_ini: this.state.registro.ativa_km_ini,
      ativa_km_fim: this.state.registro.ativa_km_fim,
      ativa_km: this.state.registro.ativa_km,
      ativa_qtde_comb: this.state.registro.ativa_qtde_comb,
    };

    this.props.onSalvarClick(registro);
  };



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['ativ_usuario'] = event.ativ_usuario;
    this.setState(event);
  }

  onChangeAtividade = event => {
    const { registro } = this.state;
    registro['ativ_atividade'] = event.ativ_atividade;
    this.setState(event);
  }

  onChangeMotivo = event => {
    const { registro } = this.state;
    registro['ativv_motivo_visita'] = event.ativv_motivo_visita;
    this.setState(event);
  }

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['ativv_cliente'] = event.ativv_cliente;
    this.setState(event);
  }

  onInputChangeKm = event => {
    const value = event;
    const id = 'ativa_km';
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  }

  onInputChangeKmIni = event => {
    const value = event;
    const id = 'ativa_km_ini';
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value },
      this.calculoKmRodado(value, this.state.registro.ativa_km_fim)
    );
  }

  onInputChangeKmFim = event => {
    const value = event;
    const id = 'ativa_km_fim';
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value },
      this.calculoKmRodado(this.state.registro.ativa_km_ini, value)
    );
  }

  calculoKmRodado = (ativa_km_ini, ativa_km_fim) => {
    const kmRodado = parseFloat(ativa_km_ini) > 0 && parseFloat(ativa_km_fim) > 0 ? parseFloat(ativa_km_fim) - parseFloat(ativa_km_ini) : 0;
    this.setState({
      registro: {
        ...this.state.registro,
        ativa_km_rodado: kmRodado > 0 ? kmRodado : 0,
      },
    });
  }

  onInputChangeHoraIni = (time, timeString) => {
    this.setState({
      registro: {
        ...this.state.registro,
        ativ_hora_ini: timeString ? timeString : '00:00',
      },
    });
  }

  onInputChangeHoraFim = (time, timeString) => {
    this.setState({
      registro: {
        ...this.state.registro,
        ativ_hora_fim: timeString ? timeString : '00:00',
      },
    });
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { ativ_idf, ativ_atividade, ativ_data_ativ, ativ_usuario, ativ_obs, ativ_hora_ini, ativ_hora_fim,
      ativ_data_checkin, ativ_local_checkin, ativ_data_checkout, ativ_local_checkout,
      ativv_cliente, ativv_nome_cliente, ativv_venda, ativr_relatorio, ativv_motivo_visita,
      ativa_km_ini, ativa_km_fim, ativa_km_rodado, ativa_km, ativa_qtde_comb } = this.state.registro;

    // console.log('AtividadeForm.this.state: ', this.state);

    return (
      <Modal
        title={ativ_idf ? (this.state.visualizando ? "Atividade" : "Edição de Atividade") : "Inclusão de Atividade"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 30 }}
      >

        <div style={{}}>
          <Form>
            <Row>

              <Col xs={24} sm={12} style={{ marginTop: 0 }}>
                <span>Data Atividade</span>
                <InputForm
                  type="date"
                  id="ativ_data_ativ"
                  ref="ativ_data_ativ"
                  value={ativ_data_ativ}
                  masker={maskDate}
                  validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                  dateFormat="DD/MM/YYYY"
                  onChange={this.onChange}
                  errorMessage="Formato correto DD/MM/AAAA"
                  className="input-data-avaliacao"
                  style={{ width: "100%" }}
                />
              </Col>


              <Col xs={24} sm={12} style={{ marginTop: 0 }}>
                <UsuarioFrame
                  label="Vendedor"
                  id="ativ_usuario"
                  value={ativ_usuario}
                  width={"100%"}
                  vendedor={1}
                  todasEmpresas={this.state.usuario ? this.state.usuario.emp_codigo : 999999}
                  onChange={this.onChangeVendedor}
                  descricaoPrimeiroItem="Selecione um Usuário"
                  disabled={getTemPermissao('UsuarioSupervisor', 'cons') ? false : true}
                />
              </Col>

              <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                <Col xs={24} sm={12} style={{ marginTop: 0 }} className="camposEspacoDireita">
                  <span>Hora Início</span>
                  <div style={{ marginTop: 4 }}>
                    <TimePicker
                      format={formatHora}
                      onChange={this.onInputChangeHoraIni}
                      value={moment(ativ_hora_ini, formatHora)}
                      minuteStep={10}
                      style={{ width: "100%" }}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={12} style={{ marginTop: 0 }} className="camposEspacoDireita">
                  <span>Hora Fim</span>
                  <div style={{ marginTop: 4 }}>
                    <TimePicker
                      format={formatHora}
                      onChange={this.onInputChangeHoraFim}
                      value={moment(ativ_hora_fim, formatHora)}
                      minuteStep={10}
                      style={{ width: "100%" }}
                    />
                  </div>
                </Col>
              </Col>


              <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                <TipoAtividadeFrame
                  label="Atividade"
                  id="ativ_atividade"
                  value={ativ_atividade}
                  width={"100%"}
                  vendedor={1}
                  onChange={this.onChangeAtividade}
                />
              </Col>

              <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                <span>Descrição da Atividade</span>
                <InputForm
                  id="ativ_obs"
                  ref="ativ_obs"
                  value={ativ_obs}
                  maxLength={100}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>


              {ativ_atividade.key === '1' ? (
                <div>
                  <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <MotivoVisitaFrame
                      label="Motivo da Visita"
                      id="ativv_motivo_visita"
                      value={ativv_motivo_visita}
                      width={"100%"}
                      vendedor={1}
                      onChange={this.onChangeMotivo}
                    />
                  </Col>
                  <Col xs={24} sm={12} style={{ marginTop: -20 }} className="campoCheckBox">
                    <InputForm
                      type="checkbox"
                      id="ativv_venda"
                      ref="ativv_venda"
                      onChange={this.onChange}
                      value={ativv_venda}
                    >
                      Venda Efetuada
                    </InputForm>
                  </Col>
                  <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                    <PessoaFrame
                      label="Cliente Cadastrado"
                      id="ativv_cliente"
                      value={ativv_cliente}
                      tipo="C"
                      width={"100%"}
                      onChange={this.onChangePessoa}
                      descricaoPrimeiroItem="Selecione um Cliente"
                    />
                  </Col>
                  <Col xs={24} sm={24} style={{ marginTop: -20, }}>
                    <span>Cliente não Cadastrado</span>
                    <InputForm
                      id="ativv_nome_cliente"
                      ref="ativv_nome_cliente"
                      value={ativv_nome_cliente}
                      maxLength={60}
                      onChange={this.onChange}
                      validator={value => Boolean(value)}
                    />
                  </Col>
                  <Col xs={24} style={{ marginTop: -20 }}>
                    <span>Relatório da Visita</span>
                    <InputForm
                      id="ativr_relatorio"
                      ref="ativr_relatorio"
                      value={ativr_relatorio}
                      type="textarea"
                      rows={3}
                      maxLength={9500}
                      onChange={this.onChange}
                      validator={value => Boolean(value)}
                    />
                  </Col>
                </div>
              ) : null}


              {ativ_atividade.key === '3' ? (
                <div>
                  <Col xs={24} sm={8} style={{ marginTop: -25 }} className="camposEspacoDireita">
                    <span style={{ fontSize: 13, paddingBottom: 5 }}>Odômetro Inicial</span>
                    <div style={{ marginTop: 4 }}>
                      <InputNumber
                        ref="Input"
                        id={ativa_km_ini}
                        value={ativa_km_ini}
                        onChange={this.onInputChangeKmIni}
                        min={0}
                        max={999999}
                        maxLength={6}
                        style={{ width: '100%' }}
                      />
                    </div>
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -25 }} className="camposEspacoDireita">
                    <span style={{ fontSize: 13, paddingBottom: 5 }}>Odômetro Final</span>
                    <div style={{ marginTop: 4 }}>
                      <InputNumber
                        ref="Input"
                        id={ativa_km_fim}
                        value={ativa_km_fim}
                        onChange={this.onInputChangeKmFim}
                        min={0}
                        max={999999}
                        maxLength={6}
                        style={{ width: '100%' }}
                      />
                    </div>
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -25 }} className="camposEspacoDireita">
                    <span style={{ fontSize: 13, paddingBottom: 5 }}>Km Rodado</span>
                    <div style={{ marginTop: 4 }}>
                      <InputNumber
                        ref="Input"
                        id={ativa_km_rodado}
                        value={ativa_km_rodado}
                        min={0}
                        max={999999}
                        maxLength={6}
                        style={{ width: '100%' }}
                        disabled={true}
                      />
                    </div>
                  </Col>

                </div>
              ) : null}

              {ativ_atividade.key === '4' ? (
                <span>
                  <Col xs={24} sm={12} style={{ marginTop: -25, }} className="camposEspacoDireita">
                    <span style={{ fontSize: 13 }}>Odômetro</span>
                    <div style={{ marginTop: 3 }}>
                      <InputNumber
                        ref="Input"
                        id={ativa_km}
                        value={ativa_km}
                        onChange={this.onInputChangeKm}
                        min={0}
                        max={999999}
                        maxLength={6}
                        style={{ width: '100%' }}
                      />
                    </div>
                  </Col>
                  <Col xs={24} sm={12} style={{ marginTop: -25, }}>
                    <span style={{ fontSize: 13 }}>Qtde Litros</span>
                    <InputForm
                      type="number"
                      id="ativa_qtde_comb"
                      ref="ativa_qtde_comb"
                      value={ativa_qtde_comb}
                      onChange={this.onChange}
                    />
                  </Col>
                </span>
              ) : <span>.</span>}

            </Row>

          </Form>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizando ? null : (
                  <Button
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="botoesModalForm2x"
                  >
                    Salvar
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AtividadeForm.js